import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  CusttomScrollBar,
  SearchViewBlock,
  SearchResultBlock,
  SearchNoResultBlock,
} from './style';
import { BasicView } from '../BasicView';
import { StripesView } from '../StripesView';
import { CollapseView } from '../CollapseView';
import { connect } from 'react-redux';
import _ from 'lodash';
import wixService from '../../../../../../services/wixService';
import {
  ensureRicosContent,
  ensureDraftContent,
} from 'ricos-content/libs/converters';

class SearchView extends React.Component {
  constructor(props) {
    super(props);
  }

  searchInAnswer = (answerBlock, searchText) => {
    for (let i = 0; i < answerBlock.length; i++) {
      if (answerBlock[i].text.toLowerCase().indexOf(searchText) > -1) {
        return true;
      }
    }
    return false;
  };

  // searchInAnswer = (answerNodes, searchText) => {
  //   for (let i = 0; i < answerNodes.length; i++) {
  //     if (answerNodes[i]?.nodes[0]?.textData?.text.toLowerCase().indexOf(searchText) > -1) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  render() {
    const { questions, settings, design, styleParams, searchValue, t } =
      this.props;
    const searchText = wixService.deepClone(searchValue).toLowerCase();
    // const questionsToShow = _.sortBy(
    //   questions.filter(
    //     (q) =>
    //       q.question.toLowerCase().indexOf(searchText) > -1 ||
    //       this.searchInAnswer(ensureRicosContent(q.answer.nodes), searchText),
    //   ),
    //   'sortOrder',
    // );
    const questionsToShow = _.sortBy(
      questions.filter(
        (q) =>
          q.question.toLowerCase().indexOf(searchText) > -1 ||
          this.searchInAnswer(q.answer.blocks, searchText),
      ),
      'sortOrder',
    );

    let flexGrowClasses = '';
    if (settings.isFixedHeight) {
      flexGrowClasses =
        'flex-column flexbox-grow fixedScrollbar ' +
        (settings.isRTL ? 'paddingLeft ' : 'paddingRight');
    }
    return (
      <>
        <SearchViewBlock>
          <SearchResultBlock
            style={{ display: questionsToShow.length !== 0 ? 'block' : 'none' }}
            styleParams={styleParams}
            design={design}
          >
            <section
              className={
                settings.isStripes
                  ? 'showingResultsFor-layout-stripes'
                  : 'showingResultsFor-collapse-or-basic'
              }
            >
              <span className="label">{t('showingResultsFor')}</span>
              <span className={'searchValue ' + settings.direction}>
                {searchValue}
              </span>
              <span
                id="live"
                role="alert"
                aria-live="polite"
                className="sr-only"
              >
                {questionsToShow.length > 0
                  ? questionsToShow.length +
                    '&nbsp;' +
                    ' ' +
                    t('results.aria.label')
                  : t('noResults')}
              </span>
            </section>
          </SearchResultBlock>
          <SearchNoResultBlock
            className={
              settings.isStripes ? 'layout-stripes' : 'collapse-or-basic'
            }
            style={{ display: questionsToShow.length === 0 ? 'block' : 'none' }}
            dangerouslySetInnerHTML={{ __html: t('noResults') }}
            styleParams={styleParams}
            design={design}
          />
        </SearchViewBlock>
        <CusttomScrollBar
          style={{ display: questionsToShow.length !== 0 ? 'block' : 'none' }}
          className={flexGrowClasses}
          styleParams={styleParams}
          design={design}
          settings={settings}
        >
          <div id="accordion" className="component-main">
            {settings.isBasic && (
              <BasicView
                className="question-basic-view"
                questions={questionsToShow}
              />
            )}
            {settings.isStripes && (
              <StripesView
                className="question-stripes-view"
                questions={questionsToShow}
              />
            )}
            {settings.isCollapse && (
              <CollapseView questions={questionsToShow} isDeepLink={true} />
            )}
          </div>
        </CusttomScrollBar>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SearchView));
